module.exports = __webpack_public_path__ + "img/gather_sleeve_opening.38d7ef97.png";